import alignElement from './align/alignElement';
import alignPoint from './align/alignPoint';

export { alignElement, alignPoint };

export default alignElement;


//////////////////
// WEBPACK FOOTER
// ./node_modules/dom-align/es/index.js
// module id = 437
// module chunks = 0 1